const VIDEO_ACCESS_STORAGE_KEY = 'videoAccess';
const VIDEO_ACCESS_TTL_MS = 30 * 24 * 60 * 60 * 1000;

function isExpired(unlockedAt) {
  if (!unlockedAt) return false;
  return Date.now() - Number(unlockedAt) > VIDEO_ACCESS_TTL_MS;
}

export function getStoredVideoAccess() {
  try {
    const raw = localStorage.getItem(VIDEO_ACCESS_STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;

    const unlockedAt = parsed.unlockedAt || null;
    if (isExpired(unlockedAt)) {
      localStorage.removeItem(VIDEO_ACCESS_STORAGE_KEY);
      return null;
    }

    // Backfill timestamp for legacy entries created before TTL support.
    if (!unlockedAt) {
      const withTimestamp = { ...parsed, unlockedAt: Date.now() };
      localStorage.setItem(VIDEO_ACCESS_STORAGE_KEY, JSON.stringify(withTimestamp));
      return withTimestamp;
    }

    return parsed;
  } catch {
    return null;
  }
}

export function hasValidVideoAccess() {
  return Boolean(getStoredVideoAccess());
}

export function setStoredVideoAccess(data) {
  try {
    const payload = {
      ...(data || {}),
      unlockedAt: data?.unlockedAt || Date.now(),
    };
    localStorage.setItem(VIDEO_ACCESS_STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // noop
  }
}

export function updateStoredVideoAccess(patch) {
  const current = getStoredVideoAccess();
  if (!current) return;
  setStoredVideoAccess({
    ...current,
    ...(patch || {}),
    unlockedAt: current.unlockedAt || Date.now(),
  });
}

// A diferencia de updateStoredVideoAccess (que solo actualiza si ya había un
// registro), esta función lo CREA si no existe. La necesita el formulario
// cualificatorio: quien llega directo a /form sin haber desbloqueado el video
// en ese navegador (link por correo, o pasaron los 30 días del TTL) no tiene
// nada guardado, y si solo actualizáramos, no se guardaría nada. Sin registro,
// /qualified no tiene de dónde sacar el email y Meta se queda sin la
// conversión CompleteRegistration.
//
// Efecto colateral: al crear el registro, setStoredVideoAccess le pone
// unlockedAt (igual que cuando se desbloquea el video desde la home). O sea
// que si esta persona vuelve a la home en el mismo navegador, va a ver el
// video ya desbloqueado. Es aceptable — acaba de completar el formulario
// entero — pero queda dicho para que no sea sorpresa.
export function guardarContactoDelFormulario(datos) {
  try {
    const limpio = Object.fromEntries(
      Object.entries(datos || {}).filter(([, valor]) => {
        if (valor == null) return false;
        if (typeof valor === 'string' && valor.trim() === '') return false;
        return true;
      })
    );

    // Si no queda ningún campo con valor, no hay nada que guardar: un registro
    // sin datos no le sirve a /qualified (no tiene correo que mandarle a Meta)
    // y de paso le desbloquearía el video a alguien que no dejó ni un dato.
    if (Object.keys(limpio).length === 0) return;

    const current = getStoredVideoAccess();
    if (!current) {
      setStoredVideoAccess(limpio);
      return;
    }

    updateStoredVideoAccess(limpio);
  } catch {
    // noop
  }
}
